import { useHouseholds } from '@platewell/query';

/**
 * People belong to several households — their own, a partner's, a parent's — and the
 * choice is per device rather than per account, because the phone in the kitchen and the
 * laptop in the office are often used for different ones.
 *
 * When there's only one household, the switcher stays out of the way; new households are
 * created from Profile.
 */
export function HouseholdSwitcher() {
  const { households, activeHouseholdId, setActiveHousehold } = useHouseholds();

  if (households.length <= 1) return null;

  return (
    <div className="field">
      <span className="label">Household</span>
      <select
        className="select"
        value={activeHouseholdId ?? ''}
        onChange={(event) => setActiveHousehold(event.target.value)}
      >
        {households.map((household) => (
          <option key={household.id} value={household.id}>
            {household.name}
            {household.role === 'viewer' ? ' (view only)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
